import React, {useState,useEffect} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { request } from './Request';
import { ResponseResult } from '../types';

const ProtectedRoute = ({setRole,...props}:any) => {

	const [returnedRoute, setRoute] = useState<JSX.Element>();

	useEffect(()=>{
		if(!setRole){
			setRoute( localStorage.token ? <Route {...props} /> : <Redirect to="/"/>);
		}else{
			request('/api/auth/me/admin',{})
			.then((result:ResponseResult)=>{
				if(result.data){
					setRoute(<Route {...props} />);
				}else{
					setRoute(<Redirect to="/"/>);
				}
			})
		}
	},[]);

	return <>{ returnedRoute }</>
};

export default ProtectedRoute;
